export const PhoneIcon = () => {
  return (
    <svg
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5018 13.3957V15.7707C17.5027 15.9912 17.4576 16.2094 17.3692 16.4115C17.2809 16.6135 17.1514 16.7948 16.9889 16.9439C16.8264 17.0929 16.6346 17.2064 16.4258 17.277C16.2169 17.3477 15.9956 17.3739 15.776 17.3541C13.3399 17.0894 10.9999 16.2569 8.94392 14.9236C7.03112 13.7082 5.4094 12.0864 4.19392 10.1736C2.85599 8.10835 2.02336 5.75693 1.76351 3.30989C1.74372 3.09097 1.76974 2.87033 1.8399 2.66201C1.91006 2.4537 2.02283 2.26227 2.17103 2.09993C2.31923 1.93758 2.4996 1.80787 2.70067 1.71906C2.90175 1.63024 3.11911 1.58427 3.33892 1.58406H5.71392C6.09812 1.58028 6.47059 1.71633 6.7619 1.96686C7.05321 2.21738 7.24348 2.56529 7.29726 2.94573C7.3975 3.70578 7.5834 4.45205 7.85142 5.17031C7.95794 5.45367 7.98099 5.76162 7.91785 6.05767C7.85471 6.35373 7.70802 6.62548 7.49517 6.84073L6.48976 7.84614C7.61674 9.82812 9.25778 11.4692 11.2398 12.5961L12.2452 11.5907C12.4604 11.3779 12.7322 11.2312 13.0282 11.1681C13.3243 11.1049 13.6322 11.128 13.9156 11.2345C14.6338 11.5025 15.3801 11.6884 16.1402 11.7886C16.5247 11.8429 16.8759 12.0366 17.127 12.3329C17.3781 12.6292 17.5115 13.0075 17.5018 13.3957Z"
        stroke="#475569"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
